export class TokenModel {
	access_token! : string;
	token_type! : string;
    expires_at! : number;

    constructor(access_token:string, token_type:string, expires_at:number) {
        this.access_token = access_token;
        this.token_type = token_type;
        this.expires_at = expires_at;
    }
}